import React from 'react';
import { useGridApiContext } from '@mui/x-data-grid';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';

const InsurerSelect = ({ id, value, field, row, colDef }) => {
	const apiRef = useGridApiContext();

	const options = Array.isArray(colDef?.valueOptions)
		? colDef.valueOptions
		: colDef?.valueOptions
			? (colDef?.valueOptions(row) ?? [])
			: [];

	const val = options?.find((o) => o?.code === value)?.code ?? '';

	const handleChange = async (event) => {
		const newValue = event.target.value;

		// Update the cell value in the DataGrid
		await apiRef.current.setEditCellValue({ id, field, value: newValue });

		// Exit edit mode
		apiRef.current.stopCellEditMode({ id, field });
	};

	const handleClose = (event, reason) => {
		if (reason === 'backdropClick') {
			apiRef.current.stopCellEditMode({ id, field });
		}
	};

	return (
		<Select
			value={val}
			onChange={handleChange}
			MenuProps={{ onClose: handleClose }}
			sx={{
				height: '100%',
				'& .MuiSelect-select': {
					display: 'flex',
					alignItems: 'center',
					pl: 1,
				},
			}}
			autoFocus
			fullWidth
			open
		>
			{options.map((option) => {
				return (
					<MenuItem
						key={option?.code ?? -1}
						value={option?.code ?? -1}
						disabled={option?.disabled}
					>
						<ListItemText primary={option?.name ?? ''} />
						{/* <ListItemIcon sx={{ minWidth: 36 }}>{code}</ListItemIcon>
						<ListItemText
							primary={tooltip}
							sx={{
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								whiteSpace: 'nowrap',
							}}
						/> */}
					</MenuItem>
				);
			})}
		</Select>
	);
};

InsurerSelect.displayName = 'InsurerSelect';

export function renderInsurerSelect(params) {
	// console.log('renderInsurerSelect PARAMS', params);
	return <InsurerSelect {...params} />;
}
